import React, { useState } from 'react';
// 画面テストが完了次第prdに反映させたいため、コメントアウト
// 【戻し方①】下記のコメントアウトされた import を有効にし、その下の import { useLocation, useNavigate } の行を削除する
// import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
// 画面テストが完了次第prdに反映させたいため、コメントアウト
// 【戻し方②】下記のコメントアウトされた import を有効にし、その下の import { Plus, ... } ブロックを削除する
// import {
//   Plus,
//   Monitor,
//   ImageIcon,
//   Smartphone,
//   Heart,
//   Layers
// } from 'lucide-react';
import {
  Plus,
  Monitor,
  ImageIcon,
  Smartphone,
  Heart,
} from 'lucide-react';
import './ElegantSidebar.css';
import apiClient from '../../api/axiosConfig';
import { getBaseUrl } from "../../../config/urls";

interface MenuItemProps {
  id: string;
  label: string;
  path: string;
  icon: React.ReactNode;
  description?: string;
}

type Screen = {
  ret: boolean | string;
  msg: string;
};

const ElegantSidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  
  const urlBase = getBaseUrl();
  const urlScreen = `${urlBase}/api/picture/screen`;

  // enterScreen相当のメソッド
  const handleScreenClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    
    // roomIdを取得（sessionStorageから）
    const roomId = sessionStorage.getItem('roomid');
    if (!roomId?.trim()) {
      alert("ルームIDが設定されていません。先にルームを作成してください。");
      return;
    }

    // 認証トークンの存在確認
    const token = localStorage.getItem("token");
    if (!token) {
      alert("認証が必要です。ログインしてください。");
      navigate('/auth/login');
      return;
    }

    setIsLoading(true);
    try {
      console.log('Sidebar: Making request to:', `${urlScreen}?roomId=${roomId}`);
      console.log('Sidebar: Token exists:', !!token);
      
      // 認証トークンを自動で追加するapiClientを使用
      const response = await apiClient.get<Screen>(`/api/picture/screen?roomId=${encodeURIComponent(roomId)}`);
      
      console.log('Sidebar: Screen API response:', response.data);
      
      if (response.data.ret === "true") {
        window.open(`/admin/screen?roomid=${roomId}`, '_blank');
      } else if (response.data.ret === "false") {
        alert(`ルームID[${roomId}]は存在しません`);
      } else {
        alert("サーバーでエラーが発生しています");
      }
    } catch (error: any) {
      console.error('Sidebar: GETリクエストが失敗しました', error);
      
      // エラーの詳細に基づいてユーザーフレンドリーなメッセージを表示
      if (error.response?.status === 401) {
        alert('認証エラーが発生しました。再度ログインしてください。');
        navigate('/auth/login');
      } else if (error.response?.status === 403) {
        alert('アクセス権限がありません。管理者にお問い合わせください。');
      } else if (error.response?.status === 404) {
        alert(`スクリーンAPIエンドポイントが見つかりません。\nURL: ${urlBase}/api/screen\n\nサーバーが起動していることを確認してください。`);
      } else if (error.response?.status >= 500) {
        alert('サーバーエラーが発生しました。しばらく時間をおいて再度お試しください。');
      } else if (error.code === 'ECONNREFUSED' || error.message.includes('Network Error')) {
        alert(`サーバーに接続できません。\nサーバーURL: ${urlBase}\n\nSpring Bootサーバーが起動していることを確認してください。`);
      } else {
        console.error('Sidebar: Unknown error:', error);
        alert(`通信エラーが発生しました。\nエラー: ${error.message}\nネットワーク接続を確認してください。`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const menuItems: MenuItemProps[] = [
    {
      id: 'room-create',
      label: 'ルーム作成',
      path: '/admin/room-create',
      icon: <Plus size={20} />,
      description: 'フォトルームを作成'
    },
    {
      id: 'screen',
      label: 'スクリーン画面',
      path: '/screen',
      icon: <Monitor size={20} />,
      description: '大画面表示モード'
    },
    // 画面テストが完了次第prdに反映させたいため、コメントアウト
    // 【戻し方③】下記 heart-animation・scatter-gallery の2ブロックのコメントを外す
    // {
    //   id: 'heart-animation',
    //   label: 'アニメーション２',
    //   path: '/admin/heart-animation',
    //   icon: <Heart size={20} />,
    //   description: 'ハートアニメーション'
    // },
    // {
    //   id: 'scatter-gallery',
    //   label: 'アニメーション３',
    //   path: '/admin/scatter-gallery',
    //   icon: <Layers size={20} />,
    //   description: 'スキャッターアニメーション'
    // },
    {
      id: 'gallery',
      label: '検閲一覧画面',
      path: '/admin/gallery',
      icon: <ImageIcon size={20} />,
      description: '写真の管理と承認'
    },
    {
      id: 'swipe-check',
      label: '検閲スワイプ画面',
      path: '/admin/swipe-check',
      icon: <Smartphone size={20} />,
      description: 'スワイプで簡単承認'
    }
  ];

  const isActivePath = (path: string): boolean => {
    return location.pathname === path;
  };

  return (
    <div className="elegant-sidebar">
      {/* Header Section */}
      <div className="sidebar-header">
        <div className="header-icon">
          <Heart size={24} />
        </div>
        {/* <h1 className="header-title">Photo Memorial</h1> */}
        <p className="header-subtitle">Wedding Management</p>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          // スクリーン画面ボタンの場合は特別処理
          // if (item.id === 'screen') {
            return (
              <button
                key={item.id}
                onClick={async (e) => {
                  e.preventDefault();

                  if (isLoading) return;
                  setIsLoading(true);

                  try {
                    if (item.id === 'screen') {
                      await handleScreenClick(e);
                    } else if (item.id === 'heart-animation') {
                      const roomId = sessionStorage.getItem('roomid');
                      if (roomId) {
                        window.open(`/admin/heart-animation?roomid=${roomId}`, '_blank');
                      } else {
                        alert("ルームIDが設定されていません。先にルームを作成してください。");
                      }
                    } else if (item.id === 'scatter-gallery') {
                      const roomId = sessionStorage.getItem('roomid');
                      if (roomId) {
                        window.open(`/admin/scatter-gallery?roomid=${roomId}`, '_blank');
                      } else {
                        alert("ルームIDが設定されていません。先にルームを作成してください。");
                      }
                    } else {
                      // それ以外は通常遷移
                      navigate(item.path);
                    }
                  } catch (error) {
                    console.error(`${item.id} メニュークリック時のエラー:`, error);
                    alert("処理中にエラーが発生しました");
                  } finally {
                    setIsLoading(false);
                  }
                }}
                className={`nav-item ${isActivePath(item.path) ? 'active' : ''} ${isLoading ? 'loading' : ''}`}
                disabled={isLoading}
              >
                <div className="nav-content">
                  <div className="nav-icon">{item.icon}</div>
                  <div className="nav-text">
                    <h3 className="nav-label">{item.label}</h3>
                    {item.description && <p className="nav-description">{item.description}</p>}
                  </div>
                  {isActivePath(item.path) && <div className="active-indicator"></div>}
                </div>
                <div className="decoration-top"></div>
                <div className="decoration-bottom"></div>
              </button>
            );
        })}
      </nav>

    </div>
  );
};

export default ElegantSidebar;